<template>
  <div class="tourists-kids">
    <tourists-quantity-group
        :value="localKids.length"
        label="Дети"
        :min="0"
        @change="on_change_quantity"
    />

    <tourists-kid-age v-for="(age, index) in kids"
                      :key="index"
                      :index="index"
                      :age="age"
                      :min_age="min_age"
                      @change="on_change_age"
    />
  </div>

</template>
<script>
  import TouristsQuantityGroup from "./TouristsQuantityGroup";
  import TouristsKidAge from "./TouristsKidAge";

  export default {
    components:{TouristsQuantityGroup, TouristsKidAge},
    props:['kids', 'min_age'],
    data() {
      return {
        localKids: this.kids,
      }
    },
    methods:{
      on_change_quantity(q){
        // console.log(q);
        if (q < this.localKids.length) {
          this.localKids.splice(q);
        } else {
          this.localKids.push(undefined);
        }
        this.$emit('change', this.localKids);
      },
      on_change_age(index, age){
        this.localKids.splice(index, 1, age);
        this.$emit('change', this.localKids);
      },
    }

  }
</script>